export enum FactsLabelsEnum {
  PRIS = 'pris',
  LANGD = 'langd',
  VIKTIGA_LANKAR = 'viktiga-lankar',
  VIKTIGA_TELEFONNUMMER = 'viktiga-telefonnummer',
  ANDRA_ORD_FOR_CAUSE = 'andra-ord-for-cause',
  CUSTOM = 'custom',
}
